import { createSelector } from 'reselect';
import { denormalize } from 'normalizr';
import get from 'lodash/get';
import orderBy from 'lodash/orderBy';

import * as Store from 'store';

import Schema from './schema';
import * as Types from './types';

export const getEntities = (state: Store.Types.IState) => state.news.entities;

const getDenormalizedList = createSelector<Store.Types.IState, string, Types.IEntities, number[], Types.IEntity.News[]>(
  getEntities,
  (state, name) => get(state, `news.list[${name}].ids`),
  (entities, ids) => {
    const items = denormalize({ news: ids }, { news: [Schema] }, { news: entities });
    return get(items, 'news', []) || [];
  }
);

const getSortedList = createSelector<Store.Types.IState, string, Types.IEntity.News[], Types.IEntity.News[]>(getDenormalizedList, items => {
  items = orderBy(items, ['id'], ['desc']);

  return items;
});

export const getList = createSelector<Store.Types.IState, string, Types.IEntity.News[], Types.IEntity.News[]>(getSortedList, items => items);

export const getSingle = createSelector<Store.Types.IState, number, Types.IEntities, number, Types.IEntity.News>(
  getEntities,
  (_, id) => id,
  (entities, id) => {
    let normalized;
    if (get(entities, id)) {
      normalized = denormalize({ news: id }, { news: Schema }, { news: entities });
    }

    let item = get(normalized, 'news');
    if (item) {
      return item;
    }
    return {};
  }
);
